// The resolve card's product search (cmdk `filter`): what a typed search scores
// against a product's search text (name, subheading, aliases). Tolerates a typo —
// "beats" finds Beets — because the admin types what the buyer wrote.
import { plainWords, sameWord } from "@shared/clydeEscalationText";

/**
 * 1 when the text contains the search as typed; 0.8 when every typed word starts
 * a word of the text; 0.5 when every typed word is one typo (or a plural) from a
 * word of the text (words of five letters or more — see sameWord); 0 otherwise.
 * An empty search matches everything.
 */
export function productSearchScore(text: string, search: string): number {
  const typed = search.trim().toLowerCase();
  if (!typed) return 1;
  if (text.toLowerCase().includes(typed)) return 1;
  const words = plainWords(text);
  const wanted = plainWords(typed);
  if (wanted.length === 0) return 0;
  if (wanted.every((w) => words.some((v) => v.startsWith(w)))) return 0.8;
  if (wanted.every((w) => words.some((v) => v.startsWith(w) || sameWord(v, w)))) return 0.5;
  return 0;
}
